import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  CheckCircle as SuccessIcon,
  Error as ErrorIcon,
  Warning as WarningIcon,
  Info as InfoIcon
} from '@mui/icons-material';
import React from 'react';

// Styles personnalisés pour les différents types de notifications
const notificationStyles = {
  success: {
    backgroundColor: '#10B981',
    icon: <SuccessIcon style={{ color: 'white' }} />
  },
  error: {
    backgroundColor: '#EF4444',
    icon: <ErrorIcon style={{ color: 'white' }} />
  },
  warning: {
    backgroundColor: '#F59E0B',
    icon: <WarningIcon style={{ color: 'white' }} />
  },
  info: {
    backgroundColor: '#3B82F6',
    icon: <InfoIcon style={{ color: 'white' }} />
  }
};

// Composant de contenu personnalisé pour les notifications
const NotificationContent = ({ message, type }) => {
  const style = notificationStyles[type];
  
  return (
    <div className="flex items-center">
      <div className="mr-3">
        {style.icon}
      </div>
      <div className="text-white">{message}</div>
    </div>
  );
};

// Fonctions pour afficher différents types de notifications
const showNotification = (message, type) => {
  const style = notificationStyles[type];
  
  return toast(
    <NotificationContent message={message} type={type} />,
    {
      className: `bg-${type}`,
      style: { backgroundColor: style.backgroundColor },
      progressClassName: 'notification-progress-bar'
    }
  );
};

export const showSuccess = (message) => {
  return showNotification(message, 'success');
};

export const showError = (message) => {
  return showNotification(message, 'error');
};

export const showWarning = (message) => {
  return showNotification(message, 'warning');
};

export const showInfo = (message) => {
  return showNotification(message, 'info');
};

// Exporter un objet avec toutes les fonctions
const NotificationService = {
  success: showSuccess,
  error: showError,
  warning: showWarning,
  info: showInfo
};

export default NotificationService; 